import { format } from 'date-fns'

export const FORMATS = {
  short: 'MMMM d, yyyy',
}

export const formatDate = date => {
  const d = new Date(date)

  if (!date || d.toString() === 'Invalid Date') {
    return
  }

  return format(d, FORMATS.short)
}

export function formatMediumDate(dataString) {
  const options = { year: 'numeric', month: 'long', day: 'numeric' }
  return new Date(dataString).toLocaleDateString(undefined, options)
}

export const formatLongDate = (dateString) => {
  const date = new Date(dateString)
  return format(date, 'MMMM d, yyyy \'at\' hh:mm a')
}
